/**
 * The honesty ribbon for pages that still render demo data.
 *
 * Six reporting surfaces ship fixed sample numbers with no fetching. Until
 * each is wired to real data, a customer seeing a Merrell campaign under
 * their own brand's header teaches them that numbers here are decorative —
 * the most expensive lesson a reporting product can teach. This ribbon says
 * plainly what the page is. Remove it per page as real data lands
 * (PLATFORM.md §4b's table is the same list — update both together).
 */
import { FlaskConical } from 'lucide-react';

export function SampleDataRibbon() {
  return (
    <div
      role="status"
      className="sticky top-0 z-30 flex items-center justify-center gap-2 border-b border-amber-200 bg-amber-50 px-4 py-1.5 text-[12.5px] text-amber-800"
    >
      <FlaskConical className="h-3.5 w-3.5 shrink-0" aria-hidden />
      <span>
        <b>Sample data.</b> This page shows example numbers, not your account&apos;s: live reporting for it is on the roadmap.
      </span>
    </div>
  );
}
